import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const ReplaceIcon: React.FC<Props> = ({
  color = '#D4DBDE',
  width = 24,
  height = 24,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.66621 7.49617C6.1275 6.69718 6.80076 6.04132 7.61155 5.6011C8.42234 5.16088 9.33907 4.95345 10.2604 5.00173C11.1817 5.05002 12.0717 5.35214 12.8321 5.8747C13.5924 6.39726 14.1934 7.1199 14.5687 7.96273M4.51562 5.94247L4.97174 7.9182C5.04943 8.25471 5.3852 8.46452 5.72171 8.38684L7.69744 7.93072M14.331 12.4987C13.8697 13.2977 13.1964 13.9535 12.3856 14.3938C11.5748 14.834 10.6581 15.0414 9.73679 14.9931C8.81546 14.9449 7.92544 14.6427 7.1651 14.1202C6.40477 13.5976 5.80376 12.875 5.42851 12.0321M15.4816 14.0524L15.0254 12.0767C14.9478 11.7402 14.612 11.5303 14.2755 11.608L12.2997 12.0641"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);
